import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { UpdateRecordParams, UpdateRecordResponse } from '../services/common/common.types';
import { commonService } from '../services/common/common.service';


/**
 * Update Record Mutation
 */
export const useUpdateRecordMutation = (
    options?: UseMutationOptions<
        UpdateRecordResponse,
        Error,
        { tableName: string; payload: UpdateRecordParams }
    >
) => {
    return useMutation<
        UpdateRecordResponse,
        Error,
        { tableName: string; payload: UpdateRecordParams }
    >({
        mutationFn: ({ tableName, payload }) =>
            commonService.updateRecord(tableName, payload),
        ...options,
    });
};